<template>

  <v-container fluid>
    <DialogMissingCmp ref="myDialog"></DialogMissingCmp>
    <v-layout row wrap justify-space-around>
      <v-flex
        shrink
        pa-1
        v-for="item in list" :key="item.id" :class="'moduleButton pointer ' + item.id" @click="openModul(item)"
      >
        <v-card
          flat
          color="transparent"
          @click="openModul(item)"
        >
          <v-hover>
            <v-img height="107" width="251" slot-scope="{ hover }" :src="getImageUrl(item, hover)">
              <v-layout pa-2 column fill-height class="title font-weight-regular">
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <span v-if="isActive(item)" :class="'Textcolor ' + hover + 'Hover'">{{translateName(item.id.toUpperCase() + '_TITLE')}}</span>
                  <span v-if="!isActive(item)" class="TextcolorGray">{{translateName(item.id.toUpperCase() + '_TITLE')}}</span>
                </v-flex>
              </v-layout>
            </v-img>
          </v-hover>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>


<!--
  <v-content>
    <v-layout row wrap justify-start class="pt-1">
      <v-flex xs12 sm4 md4 v-for="item in list" :key="item.id" :class="'moduleButton pointer ' + item.id" @click="openModul(item)">
        <v-hover>
          <v-img height="107" width="251" slot-scope="{ hover }" :src="getImageUrl(item, hover)">
            <v-layout pa-2 column fill-height class="headline font-weight-thin">
              <v-spacer></v-spacer>
              <v-flex shrink>
                <span :class="'Textcolor ' + hover + 'Hover'">{{item.name}}</span>
              </v-flex>
            </v-layout>
          </v-img>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-content> -->

</template>

<script>
  import Vue from 'vue'
  import DialogMissingCmp from "./dialogs/DialogMissingCmp";
  import ChangelogEValueRate from "../widgets/ChangelogEValueRate";
  export default {
    name: 'ModuleList',
    components: {ChangelogEValueRate, DialogMissingCmp},
    data () {
      return {
        list: [],
      }
    },
    methods: {
      isActive: function(item) {
        return ((item.publicDB != '') || (item.privateDB != ''))
      },
      getImageUrl: function(item, hover) {

        if (!this.isActive(item)) {
          return 'static/' + item.id + '_disable.png'
        }
        if (!hover) {
          return 'static/' + item.id + '.png'
        }
        return 'static/' + item.id + '_hover.png'
      },
      translateName : function (key) {
        return Vue.i18n.translate(key)
      },
      openModul: function(item) {
        if (!this.isActive(item)) {
          // showModul aufrufen
          this.$refs.myDialog.show(item)
          return
        }
        // Vue.prototype.$api.setModule(item)
        this.$router.push('/di/Module/' + item.id)
      }
    },
    mounted () {
      this.list = Vue.prototype.$api.getModuleList()
      Vue.prototype.storage.groupData = []
      _.forEach(this.list, function(module) {
        let target = module.id
        Vue.prototype.storage.removeState('pgLastHitList_' + target)
        Vue.prototype.storage.removeState('pgLastHitList_' + target + '_Peergroup')
        Vue.prototype.storage.removeState('maskData_' + target)
        Vue.prototype.storage.removeState('maskData_' + target + '_Peergroup')
      })

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/ModuleList.vue